import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CreateRoleSkeleton = () => {
  return (
    <div className="p-3">
      {new Array(4).fill(0).map((_, idx) => (
        <div key={idx} className="row mb-3">
          <div className="col-sm-4 col-xl-2">
            <Skeleton width="60%" height={25} />
          </div>
          <div className="col-sm-8 col-xl-10">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
      ))}
      <div className="row mt-4">
        <div className="col-sm-8 offset-sm-2 d-flex justify-content-center justify-content-sm-start">
          <div className="me-1">
            <Skeleton width={120} height={35} />
          </div>
          <Skeleton width={120} height={35} />
        </div>
      </div>
    </div>
  );
};

export default CreateRoleSkeleton;
